
<script>
import store from './../../../store/index.js';

export default {
    props: {
    },

    data() {
        return {
        observers: [],
        };
    },

    computed: {
        tooltipDisplay() {
            return this.$store.getters['tooltip/tooltipDisplay'];
        },
        tooltipContent() {
            return this.$store.getters['tooltip/tooltipContent'];
        },

        tooltipPosition() {
            return this.$store.getters['tooltip/tooltipPosition'];
        },

        styleCssToolTip() {
            let elementTarget = this.$store.getters['tooltip/tooltipElementTarget'];
            if (elementTarget == null || elementTarget == undefined) return {};

            let b = elementTarget.getBoundingClientRect();

            let propsElement = {
                x: (b.x || b.left) + (document.body.scrollLeft || document.documentElement.scrollLeft),
                y: (b.y || b.top) + (document.body.scrollTop || document.documentElement.scrollTop),
                height: elementTarget.offsetHeight,
                width: elementTarget.offsetWidth,
            }

            switch (this.$store.getters['tooltip/tooltipPosition']) {
                case "left":
                    return {
                        left: propsElement.x + "px",
                        top: propsElement.y + propsElement.height / 2 + "px",
                    }

                case "right":
                    return {
                        left: propsElement.x + propsElement.width + "px",
                        top: propsElement.y + propsElement.height / 2 + "px",
                    }

                case "bottom":
                    return {
                        left: propsElement.x + propsElement.width / 2 + "px",
                        top: propsElement.y + propsElement.height + "px",
                    }

                default:
                    return {
                        left: propsElement.x + propsElement.width / 2 + "px",
                        top: propsElement.y + "px",
                    }
            }
        },
    },

    methods: {
    }


   

}

</script>

<template>
    <div v-if="tooltipDisplay" :class="['containerTooltip', tooltipPosition]" :style="styleCssToolTip">
        <p class="tooltip" v-html="tooltipContent">
       
        </p>
    </div>
</template>

<style src="./../../../assets/scss/components/tooltip.scss" lang="scss"></style>